import { MetricProject, OrgProjectJourneyMetric } from 'modules/domains/billing';
import { sortObjectListByKey, sumObjectListByKey } from 'utils/arrayHelpers';
import { TableMetric } from '../AnalyticTable';

export const createJourneyTableMetrics = (
  journeyMetrics: OrgProjectJourneyMetric[][],
  projects: Record<string, MetricProject>,
  search = '',
) => {
  // sum of all journeys per project
  const journeyProjectMetrics = journeyMetrics.map((projectMetrics) => {
    const { projectId } = projectMetrics[0];
    return {
      projectId,
      projectName: projects[projectId]?.name,
      value: sumObjectListByKey(projectMetrics, 'value'),
    };
  });

  // sort by number of journeys per project
  const sorted = sortObjectListByKey(journeyProjectMetrics, 'value', true);

  // add href to make table cell linkable to specific project
  const metrics = sorted.map((metric) => ({
    metricName: {
      label: metric.projectName,
      to: `/payments/info/journeyEventsUsage/${metric.projectId}${search}`,
    },
    values: [{ value: metric.value }],
  }));

  // Show top projects with journey events, then sum the rest into a total row
  const maxRows = 5;
  const topMetrics = metrics.slice(0, maxRows);
  const restMetrics = metrics.slice(maxRows);
  const flatValues = restMetrics.flatMap((metric) => metric.values);

  const totalMetrics: TableMetric[] = [
    ...topMetrics,
    {
      metricName: { label: 'All other projects' },
      values: [
        {
          value: flatValues.length > 0 ? sumObjectListByKey(flatValues, 'value') : 0,
        },
      ],
    },
  ];

  return metrics.length > 0 ? totalMetrics : metrics;
};
